import { SubathonDocument } from "@ailenax-overlay/shared";
import { FC } from "react";
import { AilenaxBox } from "../AilenaxBox/AilenaxBox";
import "./SimpleSubathonWidget.scss";
import { donationFormatter, secsToHumanDuration, smartFormatTime } from "@/lib/utils";

interface SimpleSubathonWidgetProps {
    subathon: SubathonDocument;
}

export const SimpleSubathonWidget: FC<SimpleSubathonWidgetProps> = ({ subathon }) => {
    return (
        <AilenaxBox className="simple-subathon-widget">
            <div className="header">
                <img src="https://static-cdn.jtvnw.net/emoticons/v2/307717233/default/dark/3.0"/>
                <div className="sub-header">
                    <div className="title">{ subathon.title }</div>
                    <div className="subtitle">{ subathon.subTitle }</div>
                </div>
                <img src="https://static-cdn.jtvnw.net/emoticons/v2/307717235/default/dark/3.0"/>
            </div>
            <div className="timer">{ smartFormatTime(subathon.startSeconds + subathon.supportedSeconds - subathon.secondsElapsed) }</div>
            <hr/>
            <div className="info-text">
                <div className="info-extend-title">
                    <span className="colored">Häschen verlängern </span><span>durch:</span>
                </div>
                { subathon.t1Seconds > 0 && (
                    <>
                        <div className="info-extend-line tier1">
                            <span>1x Sub Tier 1 = </span><span className="colored">{ secsToHumanDuration(subathon.t1Seconds) }</span>
                        </div>
                        <div className="info-extend-line tier2">
                            <span>1x Sub Tier 2 = </span><span className="colored">{ secsToHumanDuration(subathon.t1Seconds * subathon.t2Multiplier) }</span>
                        </div>
                        <div className="info-extend-line tier3">
                            <span>1x Sub Tier 3 = </span><span className="colored">{ secsToHumanDuration(subathon.t1Seconds * subathon.t3Multiplier) }</span>
                        </div>
                    </>
                )}
                { subathon.bitSeconds > 0 && (
                    <div className="info-extend-line bits">
                        <span>100 Bits = </span><span className="colored">{ secsToHumanDuration(subathon.bitSeconds * 100) }</span>
                    </div>
                )}
                { subathon.euroSeconds > 0 && (
                    <div className="info-extend-line donos">
                        <span>{donationFormatter.format(5)} = </span><span className="colored">{ secsToHumanDuration(subathon.euroSeconds * 5) }</span>
                    </div>
                )}
            </div>
        </AilenaxBox>
    )
}